import React from "react";
import Login from "components/Login";

export const LoginPage = (props) => {
  return (
    <>
      <Login {...props} />
    </>
  );
};
